export default __webpack_public_path__ + "static/media/autollelogo.7f6b4da1.png";